var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"loading"},[_c('img',{attrs:{"src":require("@/assets/img/loading_dark.svg"),"alt":""}}),_c('h1',[_vm._v("Моля, изчакайте - файлът се сваля")])])
}]

export { render, staticRenderFns }